import api from "./axios";

export const getAvailablePredefinedFilters = async () => {
  return api.get("/events/predefined-filters");
};

export const getEventList = async (params: any) => {
  return api.get("/events", { params });
};

export const getEventDetail = async (id: number) => {
  return api.get(`/events/${id}`);
};

export const getInterestsForEvent = async () => {
  return api.get("/interests");
};

export const getCausesForEvent = async () => {
  return api.get("/causes");
};

export const getActiveUsersForEvent = async () => {
  return api.get("/users/active");
};

export const getActiveNGOsForEvent = async () => {
  return api.get("/ngos");
};

export const uploadImage = async (formData: FormData) => {
  return api.post("/upload/image", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const addEvent = async (data: any) => {
  return api.post("/events", data);
};

export const updateEvent = async (id: number, data: any) => {
  return api.put(`/events/${id}`, data);
};

export const publishEvent = async (id: number) => {
  return api.patch(`/events/${id}/publish`);
};

export const unpublishEvent = async (id: number) => {
  return api.patch(`/events/${id}/unpublish`);
};

export const registerAsVolunteer = async (eventId: number) => {
  return api.post(`/events/${eventId}/volunteer/register`);
};

export const cancelRegisterAsVolunteer = async (eventId: number) => {
  return api.put(`/events/${eventId}/volunteer/cancel`);
};

export const checkIsRegisteredAsVolunteer = async (eventId: number) => {
  return api.get(`/events/${eventId}/volunteer/check`);
};

export const getEventVolunteers = async (eventId: number) => {
  return api.get(`/events/${eventId}/volunteers`);
};

export const registerAsAttendee = async (eventId: number, data: any) => {
  return api.post(`/events/${eventId}/attendee/register`, data);
};

export const checkIsRegisteredAsAttendee = async (eventId: number) => {
  return api.get(`/events/${eventId}/attendee/check`);
};

export const getEventAttendees = async (eventId: number) => {
  return api.get(`/events/${eventId}/attendees`);
};

export const viewAttendeePaymentReceipt = async (
  eventId: number,
  userId: number | null = null
) => {
  return api.get(`/events/${eventId}/attendee/payment/receipt/${userId}`);
};

export const cancelRegisterAsAttendee = async (eventId: number) => {
  return api.put(`/events/${eventId}/attendee/cancel`);
};

export const ngoMarkAsPaid = async (eventId: number, ngoId: number) => {
  return api.put(`/events/${eventId}/ngo/mark-as-paid/${ngoId}`);
};

export const ngoMarkAsUnPaid = async (eventId: number, ngoId: number) => {
  return api.put(`/events/${eventId}/ngo/mark-as-unpaid/${ngoId}`);
};
